import { ProductGender, ProductMainGroups } from '@onrunning/backstage-models';

const METADATA_SHEET_NAME = '__metadata__';
const METADATA_CELL_ACCOUNT_ID = 'Z1';
const METADATA_CELL_SIGNATURE = 'Z2';
const METADATA_CELL_VERSION = 'Z3';

/** Current template version. Increment when the column layout changes. */
const TEMPLATE_VERSION = 2;

const COL_WIDTH_PRODUCT_GROUP = 30;
const COL_WIDTH_ITEM_NUMBER = 18;
const COL_WIDTH_COLOR = 20;
const COL_WIDTH_GENDER = 12;
const COL_WIDTH_LAUNCH_DATE = 16;
const COL_WIDTH_WHOLESALE_PRICE = 18;
const COL_WIDTH_RETAILER_PRICE = 18;
const COL_WIDTH_RECEIPT_DATE = 24;
const COL_WIDTH_PO_NUMBER = 22;
const COL_WIDTH_SIZE = 10;
const COL_WIDTH_TOTAL = 12;
const COL_WIDTH_TOTAL_PRICE = 18;
const COL_WIDTH_TOTAL_RETAILER_PRICE = 18;
const COL_WIDTH_INSTRUCTIONS_LABEL = 30;
const COL_WIDTH_INSTRUCTIONS_VALUE = 50;
const COL_WIDTH_DEFAULT = 12;
const COL_WIDTH_EMPTY_SHEET = 30;

const HEADER_ROW_INDEX = 1;
const FIRST_DATA_ROW_OFFSET = 2;
const INFO_COLUMN_COUNT = 5;
const DYNAMIC_COLUMN_BASE = INFO_COLUMN_COUNT + 1;
const HEADER_ROW_HEIGHT = 30;

const FONT_SIZE_TITLE = 16;
const FONT_SIZE_SECTION = 12;
const FONT_SIZE_DEFAULT = 10;
const FONT_SIZE_SUB_HEADER = 9;

const MAX_PO_NUMBER_LENGTH = 20;
const MIN_QUANTITY = 0;
const MAX_QUANTITY = 10_000;

const DISTRIBUTOR_MOQ: Record<string, number> = {
  shoes: 5,
  accessories: 10,
};

const DEFAULT_SIZE_SYSTEM = 'us';
const DEFAULT_CURRENCY_FMT = '#,##0.00';

const COLORS = {
  headerBg: 'FF1A1A1A',
  headerFont: 'FFFFFFFF',
  subHeaderBg: 'FF4A4A4A',
  subHeaderFont: 'FFFFFFFF',
  editableBg: 'FFE8F5E9',
  editableBorder: 'FF70AD47',
  lockedBg: 'FFF5F5F5',
  disabledBg: 'FFE0E0E0',
  disabledFont: 'FF808080',
  dateEditableBg: 'FFFFF3E0',
  dateEditableBorder: 'FFFFA726',
} as const;

const CURRENCY_FORMATS: Record<string, string> = {
  USD: '[$USD] #,##0.00',
  EUR: '[$EUR] #,##0.00',
  GBP: '[$GBP] #,##0.00',
  CHF: '[$CHF] #,##0.00',
  CAD: '[$CAD] #,##0.00',
  AUD: '[$AUD] #,##0.00',
  JPY: '[$JPY] #,##0',
  CNY: '[$CNY] #,##0.00',
  KRW: '[$KRW] #,##0',
  SEK: '[$SEK] #,##0.00',
  NOK: '[$NOK] #,##0.00',
  DKK: '[$DKK] #,##0.00',
  PLN: '[$PLN] #,##0.00',
  BRL: '[$BRL] #,##0.00',
  HKD: '[$HKD] #,##0.00',
  NZD: '[$NZD] #,##0.00',
  RON: '[$RON] #,##0.00',
};

const GENDER_LABELS: Record<number, string> = {
  [ProductGender.unisex]: 'Unisex',
  [ProductGender.male]: 'Men',
  [ProductGender.female]: 'Women',
  [ProductGender.youth]: 'Youth',
  [ProductGender.kids]: 'Kids',
  [ProductGender.toddler]: 'Toddler',
};

const GENDER_TRANSLATION_KEYS: Record<number, string> = {
  [ProductGender.unisex]: 'gender_unisex',
  [ProductGender.male]: 'gender_men',
  [ProductGender.female]: 'gender_women',
  [ProductGender.youth]: 'gender_youth',
  [ProductGender.kids]: 'gender_kids',
  [ProductGender.toddler]: 'gender_toddler',
};

const CATEGORY_LABELS: Record<string, string> = {
  [ProductMainGroups.shoes]: 'Shoes',
  [ProductMainGroups.apparel]: 'Apparel',
  [ProductMainGroups.accessories]: 'Accessories',
};

const CATEGORY_TRANSLATION_KEYS: Record<string, string> = {
  [ProductMainGroups.shoes]: 'category_shoes',
  [ProductMainGroups.apparel]: 'category_apparel',
  [ProductMainGroups.accessories]: 'category_accessories',
};

export {
  CATEGORY_LABELS,
  CATEGORY_TRANSLATION_KEYS,
  COL_WIDTH_COLOR,
  COL_WIDTH_DEFAULT,
  COL_WIDTH_EMPTY_SHEET,
  COL_WIDTH_GENDER,
  COL_WIDTH_INSTRUCTIONS_LABEL,
  COL_WIDTH_INSTRUCTIONS_VALUE,
  COL_WIDTH_ITEM_NUMBER,
  COL_WIDTH_LAUNCH_DATE,
  COL_WIDTH_PO_NUMBER,
  COL_WIDTH_PRODUCT_GROUP,
  COL_WIDTH_RECEIPT_DATE,
  COL_WIDTH_RETAILER_PRICE,
  COL_WIDTH_SIZE,
  COL_WIDTH_TOTAL,
  COL_WIDTH_TOTAL_PRICE,
  COL_WIDTH_TOTAL_RETAILER_PRICE,
  COL_WIDTH_WHOLESALE_PRICE,
  COLORS,
  CURRENCY_FORMATS,
  DEFAULT_CURRENCY_FMT,
  DEFAULT_SIZE_SYSTEM,
  DISTRIBUTOR_MOQ,
  DYNAMIC_COLUMN_BASE,
  FIRST_DATA_ROW_OFFSET,
  FONT_SIZE_DEFAULT,
  FONT_SIZE_SECTION,
  FONT_SIZE_SUB_HEADER,
  FONT_SIZE_TITLE,
  GENDER_LABELS,
  GENDER_TRANSLATION_KEYS,
  HEADER_ROW_HEIGHT,
  HEADER_ROW_INDEX,
  INFO_COLUMN_COUNT,
  MAX_PO_NUMBER_LENGTH,
  MAX_QUANTITY,
  METADATA_CELL_ACCOUNT_ID,
  METADATA_CELL_SIGNATURE,
  METADATA_CELL_VERSION,
  METADATA_SHEET_NAME,
  MIN_QUANTITY,
  TEMPLATE_VERSION,
};
